import Link from 'next/link';
import { CSSProperties } from 'react';
import './index.less';

interface ExpandYourRetailNetworkProps {
  title: string;
  description: string;
  btnText: string;
  customClass?: string;
  customStyle?: CSSProperties;
  siupRedirect?: string;
}

const ExpandYourRetailNetwork = ({
  title,
  description,
  btnText,
  customStyle,
  customClass = '',
  siupRedirect,
}: ExpandYourRetailNetworkProps) => {
  return (
    <div className={`expand-your-retail-network-container ${customClass}`} style={customStyle ? customStyle : null}>
      <div className="expand-your-retail-network-container-title">
        {title?.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            {index < title.split('\n').length - 1 && <br />}
          </span>
        ))}
      </div>
      <div className="expand-your-retail-network-container-description">{description}</div>
      <Link
        href={siupRedirect ? `/sell-on-pietra/register?signup_redirect=${siupRedirect}` : '/sell-on-pietra/register'}
      >
        <button className="expand-your-retail-network-container-sign-up-for-free">{btnText}</button>
      </Link>
    </div>
  );
};

export default ExpandYourRetailNetwork;
